<template>
    <div :class="{card: true, selected: isSelected}" @click="onClick">
      <h2>{{ title }}</h2>
    <div class="score-info-container">
      <p>{{ value }}番</p>
      <InfoIcon
        fillColor="grey"
        @click.stop="showInfo"
      />
    </div>
    <div v-if="isSelected" class="quantity-controls">
      <p>x{{ quantity }}</p>
      <div class="quantity-buttons">
        <button @click.stop="addQuantity">+</button>
        <button @click.stop="minusQuantity">-</button>
      </div>
    </div>
    </div>
    <InfoCard 
      v-if="isInfoCardVisible"
      :desc=this.desc
      @close="closeInfoCard"
    />
  </template>
  
  <script>
  import InfoCard from "./InfoCard.vue"
  import InfoIcon from 'vue-material-design-icons/Information.vue';

  export default {
    components: { InfoCard, InfoIcon },
    props: {
      title: String,
      value: Number,
      desc: String,
      isSelected: Boolean,
      quantity: Number,
    },
    data() {
      return {
        isInfoCardVisible: false,
      }
    },
    methods: {
      onClick() {
        this.$emit('click')
      },
      // handle quantity count 
      addQuantity() {
        this.$emit('addQuantity')
      },
      minusQuantity() {
        this.$emit('minusQuantity')
      },
      showInfo() {
        // handle the info button click logic
        this.isInfoCardVisible = true;
        console.log(this.isInfoCardVisible); 
      },
      closeInfoCard() {
        this.isInfoCardVisible = false;
        console.log(this.isInfoCardVisible)
      }
    }
  };
  </script>
  
  <style src="./OptionCard.css"></style>